import type { Theme } from '@emotion/react'
import { css } from '@emotion/react'

export type Colors = keyof typeof colors

export const root = (theme: Theme) => css`
  cursor: pointer;
  display: block;
  padding: 0;
  outline: none;
  background: transparent;
  border: 1px solid transparent;

  &:hover,
  &:focus,
  &:active {
    text-decoration: underline;
    outline: none;
    background: transparent;
    border: 1px solid transparent;
  }

  &[disabled] {
    color: ${theme.palette.ghost.mediumContrast};
    pointer-events: none;
  }
`

export const colors = {
  primary: (theme: Theme) => css`
    color: ${theme.palette.secondary.mainContrast};
  `,
  secondary: (theme: Theme) => css`
    color: ${theme.palette.primary.mainContrast};
  `,
  warning: (theme: Theme) => css`
    color: ${theme.palette.warning.main};
  `,
  negative: (theme: Theme) => css`
    color: ${theme.palette.error.main};
  `,
  neutral: (theme: Theme) => css`
    color: ${theme.palette.tertiary.upperMediumContrast};
  `,
}

export const fullWidth = css`
  width: 100%;
`
